export default "__VITE_ASSET__9YzFhIXs__"